module.exports = __webpack_public_path__ + "5278d77e5c3f78130d850395210c338e.png";